
import {View} from 'backbone';
import template from 'dashboard/connections/details/connection-rest-services.ejs';
import ConnectionResearchView from 'dashboard/connections/details/ConnectionResearchView';
import RestService from 'RestService';
import xJService from 'xml/XJService';
import NotificationService from 'NotificationService.js';

class ConnectionRestServices extends View {
    initialize(opts){

        this.template = template;
        this.connectionService = opts.connectionService;

        this.events = {
            'change input[name=_url], input[name=_username], input[name=_password], input[name=CertificatePassphrase]': 'processConnectionInputs',
            'change #wsSources': 'setNewSource',
            'click .refresh-wssource': 'refreshSources'
        };

        this.listenTo(this.model, 'change', this.render);
       
        return this;
    }

    refreshSources(){
        this.connectionService.loadWSSources(true);
    }

    setNewSource(ev){
        this.connectionService.setNewSource(ev);
    }

   
    processConnectionInputs(){
        return this.connectionService.processConnectionInputs.apply(this.connectionService, arguments);
    }

    checkConnection(){
        return this.connectionService.checkConnection.apply(this.connectionService, arguments);
    }

    render(){

        this.connectionService.validateCertificateExpiration();
        this.connectionService.associateToSource();

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        
        this.connectionService.loadCertificateFileUpload();
        this.delegateEvents();
        return this;
    }

}

export default ConnectionRestServices;